import React from 'react'
import style from 'css/admin/SongPollResults.module.css'

export default function SongPollResults() {
    return (
        <div className={style.main}>
            Song Poll Results
        </div>
    )
}
